import React from 'react';
import { withRouter } from 'react-router-dom';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { hideSpinnerOverlay } from '../../utility/helper';
import { Button } from '@paypalcorp/pp-react';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';
import { isMobileOrInContext } from '../../utility/inContextDonation';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';
import CloseButton from '../../components/CloseButton';

class ThreeDSError extends React.Component {
  componentDidMount = () => {
    hideSpinnerOverlay();
  };

  handleTryAgain = () => {
    this.props.history.push(`/donate?token=${templateData.token}`);
  };

  render() {
    const error = localsMessages('errors/threeDSError');

    return (
      <div>
        <div
          className={`donate_wrapper confirmation ${
            isMobileOrInContext() ? 'mobile_view' : ''
          }`}
        >
          {isExternalFlow() && <CloseButton />}
          <div className="ppvx_row">
            <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
              <Illustration type="warning" />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationTitle message={error.errorMessage} />
            </div>
          </div>
          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <ConfirmationBody message={error.tryAgain} />
            </div>
          </div>

          <div className="ppvx_row">
            <div className="ppvx_col-12 text-center">
              <Button
                className="btn-wide"
                id="tryAgain"
                onClick={this.handleTryAgain}
              >
                {error.tryCard}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ThreeDSError);
